import { ReactComponent as AgencyRecruitmentIcon } from "../../icons/agency-recruitment.svg";
import { ReactComponent as TalkToOurExpertsIcon } from "../../icons/talk-to-our-experts.svg";
import { ReactComponent as DjangoIcon } from "../../icons/frameworks/django.svg";
import { ReactComponent as DrupalIcon } from "../../icons/frameworks/drupal.svg";
import { ReactComponent as MagentoIcon } from "../../icons/frameworks/magento.svg";
import { ReactComponent as LaravelIcon } from "../../icons/frameworks/laravel.svg";
import { ReactComponent as NextjsIcon } from "../../icons/frameworks/nextjs.svg";
import { ReactComponent as GoIcon } from "../../icons/languages/go.svg";
import { ReactComponent as JavaIcon } from "../../icons/languages/java.svg";
import { ReactComponent as NodejsIcon } from "../../icons/languages/nodejs.svg";
import { ReactComponent as PhpIcon } from "../../icons/languages/php.svg";
import { ReactComponent as PythonIcon } from "../../icons/languages/python.svg";
import { ReactComponent as WordpressIcon } from "../../icons/frameworks/wordpress.svg";
import { ReactComponent as SymfonyIcon } from "../../icons/frameworks/symfony.svg";
import { ReactComponent as RubyIcon } from "../../icons/languages/ruby.svg";
import { ReactComponent as AgencyPortalIcon } from "../../icons/agency-portal.svg";
const headerDataDE = {
  homepage: "/de/",
  top: [
    {
      //text: "Vertrieb kontaktieren",
      text: "Contact us",
      href: "/contact-us/",
    },
    {
      //text: "Dokumentation",
      text: "Documentation",
      href: "https://devcenter.upsun.com/",
    },
    {
      //text: "Anmelden",
      text: "Login",
      href: "https://auth.upsun.com/",
    },
  ],
  links: [
    {
      text: "Produkt",
      columns: [
        {
          title: "Produkt",
          links: [
            {
              text: "Überblick",
              href: "/de/produkt/"
            },
            {
              //text: "Funktionen",
              text: "Features",
              href: "/features/"
            },
          ]
        },
        {
          title: "Frameworks",
          links: [
            {
              text: "Django",
              href: "/django/",
              icon: <DjangoIcon />
            },
            {
              text: "Next.js",
              href: "/nextjs/",
              icon: <NextjsIcon />
            },
            {
              text: "Drupal",
              href: "/drupal/",
              icon: <DrupalIcon />
            },
            {
              text: "WordPress",
              href: "/wordpress/",
              icon: <WordpressIcon />
            },
            {
              text: "Symfony",
              href: "/symfony/",
              icon: <SymfonyIcon />
            },
            {
              text: "Magento",
              href: "/magento/",
              icon: <MagentoIcon />
            },
            {
              text: "Laravel",
              href: "/laravel/",
              icon: <LaravelIcon />
            }
          ]
        },
        {
          //title: "Sprachen",
          title: "Languages",
          links: [
            {
              text: "PHP",
              href: "/php/",
              icon: <PhpIcon />
            },
            {
              text: "Python",
              href: "/python/",
              icon: <PythonIcon />
            },
            {
              text: "Node.js",
              href: "/nodejs/",
              icon: <NodejsIcon />
            },
            {
              text: "Ruby",
              href: "/ruby/",
              icon: <RubyIcon />
            },
            {
              text: "Java",
              href: "/java/",
              icon: <JavaIcon />
            },
            {
              text: "Golang",
              href: "/go/",
              icon: <GoIcon />
            }
          ]
        }
      ]
    },
    {
      text: "Lösungen",
      columns: [
        {
          title: "Lösungen",
          links: [
            {
              text: "SaaS-Hosting",
              href: "/de/loesungen/saas/"
            },
            {
              text: "Anwendungsmodernisierung",
              href: "/de/loesungen/anwendungsmodernisierung/"
            },
            {
              text: "E-Commerce-Hosting",
              href: "/de/loesungen/ecommerce/"
            },
            {
              text: "CMS-Hosting",
              href: "/de/loesungen/cms/"
            },
            {
              text: "Verwaltung mehrerer Standorte",
              href: "/de/loesungen/verwaltung-mehrerer-standorte/"
            },
            {
              text: "SaaS-Erweiterungen",
              href: "/de/loesungen/saas-erweiterungen/"
            },
            {
              text: "Backend-Lösungen",
              href: "/de/loesungen/backend/"
            },
          ]
        },
        {
          title: "Industrie",
          links: [
            {
              text: "Einzelhandel",
              href: "/de/industrie/einzelhandel/"
            },
            {
              text: "Hochschulbildung",
              href: "/de/industrie/hochschulbildung/"
            },
            {
              text: "SaaS",
              href: "/de/industrie/saas/"
            },
            {
              text: "Reisen und Gastgewerbe",
              href: "/de/industrie/reisen-und-gastgewerbe/"
            },
            {
              text: "Finanzdienstleistungen",
              href: "/de/industrie/finanzdienstleistungen/"
            },
            {
              text: "Regierung",
              href: "/de/industrie/regierung/"
            },
          ]
        }
      ]
    },
    {
      //text: "Preise",
      text: "Pricing",
      columns: [
        {
          title: "Plans",
          links: [
            {
              text: "Flexible resources",
              href: "/pricing/"
            },
            {
              text: "Fixed resources",
              href: "/fixed-pricing/"
            },
          ]
        }
      ]
    },
    {
      text: "Partner",
      emphasizeFirstCol: true,
      columns: [
        {
          // TODO: translate
          title: "Expertise",
          links: [
            {
              // TODO: translate
              "text": "Strategic Implementation",
              "href": "/strategic-implementation-experts/",
              "desc": "Tap upsun's implementation architects for the clarity and technical pathways that turn complex projects into confident launches.",
              "cta": "See how we can help"
            }
          ]
        },
        {
          title: "",
          links: [
            {
              // TODO: translate
              "text": "Get implementation help",
              "href": "/strategic-implementation-experts/",
              "icon": <TalkToOurExpertsIcon />
            },
            {
              // TODO: translate
              "text": "Become an agency partner",
              "href": "/agency-hosting-partner/",
              "icon": <AgencyRecruitmentIcon />
            },
            {
              "text": "Log to your portal",
              "href": "https://agencypartner.platform.sh",
              "icon": <AgencyPortalIcon /> 
            },
          ]
        }
      ]
    },
    {
      //text: "Unternehmen",
      text: "Company",
      emphasizeFirstCol: true,
      columns: [
        {
          // TODO: translate
          "title": "Community",
          "links": [
            {
              "text": "Developer center",
              "href": "https://devcenter.upsun.com/",
              //desc: "Zentrale für die neuesten Upsun-Entwicklerressourcen: Finden Sie Demos, Dokumentationen und Artikel für Ihre bevorzugten Frameworks und Sprachen",
              desc: "Central for the latest Upsun developer resources: Find demos, documentation and articles for your preferred frameworks and languages",
              //cta: "Jetzt ansehen",
              cta: "Check it out",
            },
          ]
        },
        {
          "title": "Ressourcen",
          "links": [
            {
              text: "Fallstudien",
              href: "/de/blog/fallstudien/"
            },
            {
              "text": "Blog",
              "href": "/de/blog/"
            },
            {
              // TODO: translate
              "text": "Trust center",
              "href": "/trust-center/"
            },
          ]
        },
        {
          "title": "Überblick",
          "links": [
            {
              //"text": "Veranstaltungen",
              text: "Events",
              "href": "/events/",
            },
            {
              "text": "Nachrichten zum Unternehmen",
              "href": "/de/blog/nachrichten/"
            },
            {
              //"text": "Über uns",
              text: "About us",
              "href": "/about-us/",
            },
            {
              "text": "Jobs",
              "href": "/jobs/"
            },
            {
              //"text": "Nachhaltigkeit",
              text: "Sustainability",
              "href": "/greener-hosting/",
            },
            {
              "text": "FAQ",
              "href": "/faq/",
            }
          ]
        }
      ]
    },
  ],
  ctas: [
    {
      // TODO: translate
      text: "Watch a demo",
      href: "/demo/",
    },
    {
      //text: "Kostenlose Testversion",
      text: "Free trial",
      href: "https://auth.upsun.com/register",
    },
  ],
}

export default headerDataDE;